module.exports = __webpack_public_path__ + "static/media/pc-image-background-checker-pattern-1.380c482d.svg";